// extracted by mini-css-extract-plugin
export default {"card":"KanbanCard_card__Bwjr+","title":"KanbanCard_title__yiALQ","issues-container":"KanbanCard_issues-container__BlW-C"};